/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Upgrade_ProratedInputs */



/**
* | output |
* | --- |
* | "Prorated for remaining days this period" |
*
* @param {Sub_Upgrade_ProratedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_prorated = /** @type {((inputs?: Sub_Upgrade_ProratedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_ProratedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Anteilig für die verbleibenden Tage dieses Zeitraums")
	return /** @type {LocalizedString} */ ("Prorated for remaining days this period")
});